module.exports = __webpack_public_path__ + "img/hero-our-plan-mobile.d26cfd8b.jpg";